import documentSettingsEditComponent from './document-settings-edit.component';

const documentSettingsEditModule = angular.module('documentSettingsEdit', [])
  .component('documentSettingsEdit', documentSettingsEditComponent)
  .name;

export default documentSettingsEditModule;
